(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["imagen_veller_glash"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('resenas-imagen-glash')) {
    class ResenasImagenGlash extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('[data-track]');
        this.flechaIzq = this.querySelector('[data-flecha-izq]');
        this.flechaDer = this.querySelector('[data-flecha-der]');
        if (!this.pista) return;

        this.autoplayActivo = this.getAttribute('data-autoplay') === 'true';
        this.velocidadSegundos = parseFloat(this.getAttribute('data-velocidad')) || 3;
        this.temporizador = null;

        if (this.flechaIzq) {
          this.flechaIzq.addEventListener('click', () => {
            this.pausarTemporalmente();
            this.avanzar(-1);
          });
        }
        if (this.flechaDer) {
          this.flechaDer.addEventListener('click', () => {
            this.pausarTemporalmente();
            this.avanzar(1);
          });
        }

        this.pista.addEventListener('mouseenter', () => this.detenerAutoplay());
        this.pista.addEventListener('mouseleave', () => this.iniciarAutoplay());
        this.pista.addEventListener('touchstart', () => this.detenerAutoplay(), { passive: true });

        this.iniciarAutoplay();

        this.querySelectorAll('[data-util]').forEach(function (util) {
          var boton = util.querySelector('[data-util-boton]');
          var texto = util.querySelector('[data-util-texto]');
          var id = util.dataset.utilId;
          var inicial = parseInt(util.dataset.utilInicial, 10) || 0;
          var claveVoto = 'carosly_util_' + id;

          function pintar(votado) {
            var total = votado ? inicial + 1 : inicial;
            texto.textContent = total + ' personas encontraron esto útil';
            boton.classList.toggle('votado', votado);
          }

          var yaVotado = window.localStorage.getItem(claveVoto) === '1';
          pintar(yaVotado);

          boton.addEventListener('click', function () {
            var estaVotado = window.localStorage.getItem(claveVoto) === '1';
            if (estaVotado) return;
            window.localStorage.setItem(claveVoto, '1');
            pintar(true);
          });
        });
      }

      disconnectedCallback() {
        this.detenerAutoplay();
      }

      avanzar(direccion) {
        const tarjeta = this.pista.children[0];
        if (!tarjeta) return;
        const ancho = tarjeta.getBoundingClientRect().width + 16;
        const maximo = this.pista.scrollWidth - this.pista.clientWidth;

        if (direccion > 0 && this.pista.scrollLeft >= maximo - 4) {
          this.pista.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direccion < 0 && this.pista.scrollLeft <= 4) {
          this.pista.scrollTo({ left: maximo, behavior: 'smooth' });
        } else {
          this.pista.scrollBy({ left: ancho * direccion, behavior: 'smooth' });
        }
      }

      iniciarAutoplay() {
        if (!this.autoplayActivo || this.temporizador) return;
        this.temporizador = window.setInterval(() => {
          this.avanzar(1);
        }, this.velocidadSegundos * 1000);
      }

      detenerAutoplay() {
        if (this.temporizador) {
          window.clearInterval(this.temporizador);
          this.temporizador = null;
        }
      }

      pausarTemporalmente() {
        this.detenerAutoplay();
        window.setTimeout(() => this.iniciarAutoplay(), this.velocidadSegundos * 1000);
      }
    }

    customElements.define('resenas-imagen-glash', ResenasImagenGlash);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tactil-veller-glash"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('resenas-texto-glash')) {
    class ResenasTextoGlash extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('[data-track]');
        this.flechaIzq = this.querySelector('[data-flecha-izq]');
        this.flechaDer = this.querySelector('[data-flecha-der]');
        if (!this.pista) return;

        if (this.flechaIzq) {
          this.flechaIzq.addEventListener('click', () => this.avanzar(-1));
        }
        if (this.flechaDer) {
          this.flechaDer.addEventListener('click', () => this.avanzar(1));
        }

        this.querySelectorAll('[data-util]').forEach(function (util) {
          var boton = util.querySelector('[data-util-boton]');
          var texto = util.querySelector('[data-util-texto]');
          var id = util.dataset.utilId;
          var inicial = parseInt(util.dataset.utilInicial, 10) || 0;
          var claveVoto = 'carosly_util_texto_' + id;

          function pintar(votado) {
            var total = votado ? inicial + 1 : inicial;
            texto.textContent = total + ' personas encontraron esto útil';
            boton.classList.toggle('votado', votado);
          }

          var yaVotado = window.localStorage.getItem(claveVoto) === '1';
          pintar(yaVotado);

          boton.addEventListener('click', function () {
            var estaVotado = window.localStorage.getItem(claveVoto) === '1';
            if (estaVotado) return;
            window.localStorage.setItem(claveVoto, '1');
            pintar(true);
          });
        });
      }

      avanzar(direccion) {
        const tarjeta = this.pista.children[0];
        if (!tarjeta) return;
        const ancho = tarjeta.getBoundingClientRect().width;
        const maximo = this.pista.scrollWidth - this.pista.clientWidth;

        if (direccion > 0 && this.pista.scrollLeft >= maximo - 4) {
          this.pista.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direccion < 0 && this.pista.scrollLeft <= 4) {
          this.pista.scrollTo({ left: maximo, behavior: 'smooth' });
        } else {
          this.pista.scrollBy({ left: ancho * direccion, behavior: 'smooth' });
        }
      }
    }

    customElements.define('resenas-texto-glash', ResenasTextoGlash);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tallas-velller-glash"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guia-tallas-glash')) {
    class GuiaTallasGlash extends HTMLElement {
      connectedCallback() {
        this.boton = this.querySelector('[data-abrir-guia]');
        this.modal = this.querySelector('[data-modal]');
        this.botonCerrar = this.querySelector('[data-cerrar-guia]');
        if (!this.boton || !this.modal) return;

        this.boton.addEventListener('click', () => {
          this.modal.showModal();
        });

        if (this.botonCerrar) {
          this.botonCerrar.addEventListener('click', () => {
            this.modal.close();
          });
        }

        this.modal.addEventListener('click', (evento) => {
          if (evento.target === this.modal) {
            this.modal.close();
          }
        });
      }
    }

    customElements.define('guia-tallas-glash', GuiaTallasGlash);
  }
  } catch(e) { console.error(e); }
})();

})();
